module.exports = __webpack_public_path__ + "static/f_capabilities_3_1-4a8bc7053d9004e76f3cabe1f3531651.png";